import api from './api';

/**
 * Lemlist liefert Hinweise als Objekte, nicht als Zeichenketten -- ein
 * `{t}` im JSX waere bei einem Objekt ein Laufzeitfehler.
 */
export interface WarmupTip {
  type?: string;
  title?: string;
  message?: string;
}

export interface Warnung {
  art: string;
  /** warn | kritisch */
  stufe: string;
  text: string;
}

export interface Snapshot {
  id: string;
  tag: string;
  score?: number | null;
  dnsScore?: number | null;
  inboxPercent?: number | null;
  totalSent?: number | null;
  blacklistScore?: number | null;
  warmupActive: boolean;
  takenAt: string;
}

export interface Mailbox {
  id: string;
  lemlistId: string;
  email: string;
  loginEmail?: string | null;
  provider?: string | null;

  warmupActive: boolean;
  warmupStartedAt?: string | null;
  lastWarmAt?: string | null;
  nextWarmAt?: string | null;
  rampup?: number | null;
  dailyMax?: number | null;

  score?: number | null;
  dnsScore?: number | null;
  inboxPercent?: number | null;
  totalSent?: number | null;
  mailboxAge?: number | null;
  blacklistScore?: number | null;
  blacklistedIn?: string[] | null;
  mxOk?: boolean | null;
  spfOk?: boolean | null;
  dmarcOk?: boolean | null;
  tips?: WarmupTip[] | null;
  lastBouncedAt?: string | null;
  lastBounceReason?: string | null;
  lastCheckedAt: string;

  snapshots?: Snapshot[];
  warnungen: Warnung[];
  verlauf: { richtung: string; differenz: number };
}

export interface Kennzahlen {
  postfaecher: number;
  warmupAktiv: number;
  kritisch: number;
  kapazitaet: number;
  scoreSchnitt: number | null;
  zuletztGeprueft: string | null;
}

export interface AbgleichBericht {
  gefunden: number;
  neu: number;
  aktualisiert: number;
  ohneWarmup: number;
  fehler: string[];
}

const mailboxService = {
  async list(): Promise<{ postfaecher: Mailbox[]; kennzahlen: Kennzahlen }> {
    const response = await api.get('/mailboxes');
    return response.data;
  },

  async sync(): Promise<AbgleichBericht> {
    const response = await api.post('/mailboxes/sync');
    return response.data;
  },

  /** Loest Versand aus -- nur auf ausdrueckliche Handlung. */
  async startWarmup(id: string): Promise<Mailbox> {
    const response = await api.post(`/mailboxes/${id}/warmup/start`);
    return response.data;
  },
};

export default mailboxService;
